/**
 * Created by Greg on 4/20/2016.
 */
import React from 'react';
import {Modal, Button, Popover, OverlayTrigger, Row, Col, Collapse} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import {connect} from 'react-redux';

const nodeTypes = [{name: "Switch", id: "switch"},
    {name: "Host", id: "host"},
    {name: "Data Center", id: "data_center"},
    {name: "User Region", id: "user_region"}];

const nodeLayerTypes = [
    {name: "None", id: "none"},
    {name: "IP", id: "ip"},
    {name: "Ethernet", id: "ether"},
    {name: "SONET/SDH", id: "sdh"},
    {name: "G.709", id: "g709"},
    {name: "Wavelength", id: "wavelength"}
];

var NodeEditDialog = React.createClass({
    getInitialState() {
        return {
            id: null, type: null, layer: null, ipv4: null,
            mac: null,
            vnid: "",
            addrOpen: false,
            idError: null,
            ipv4Error: null,
            macError: null,
            node: {}
        };
    },

    componentWillReceiveProps(nextProps) {
        let nodeId = nextProps.netVisInteract.selectedNodes[0];
        let node = nextProps.net.nodes.find(n => n.id === nodeId);
        if (!node) {
            node = {};
        }
        this.setState(Object.assign({}, this.state, {
            id: node.id, type: node.type, layer: node.layer, ipv4: node.ipv4,
            mac: node.mac,
            vnid: node.vnid,
            addrOpen: false,
            idError: null,
            ipv4Error: null,
            macError: null,
            node: node
        }));
    },

    idChange(e) {
        let newId = e.target.value;
        this.setState(Object.assign({}, this.state, {
            id: newId,
            idError: idValidator(newId, this.props.net.nodes, this.state.node)
        }));
    },
    idStatus() {
        if (this.state.idError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    vnidChange(e) {
        let newVnid = e.target.value;
        this.setState(Object.assign({}, this.state, {
            vnid: newVnid
        }));
    },

    ipv4Change(e) {
        let newIpv4 = e.target.value;
        if (newIpv4 === "") {
            this.setState(Object.assign({}, this.state, {
                ipv4: undefined,
                ipv4Error: null
            }))
        } else {
            this.setState(Object.assign({}, this.state, {
                ipv4: newIpv4,
                ipv4Error: ipv4Validator(newIpv4, this.props.net.nodes, this.state.node)
            }));
        }
    },
    ipv4Status() {
        if (this.state.ipv4Error) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    macChange(e) {
        let newMac = e.target.value;
        if (newMac === "") {
            this.setState(Object.assign({}, this.state, {
                mac: undefined,
                macError: null
            }));
        } else {
            this.setState(Object.assign({}, this.state, {
                mac: newMac,
                macError: macValidator(newMac,  this.props.net.nodes, this.state.node)
            }));
        }
    },

    macStatus() {
        if (this.state.macError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    nodeError() {
        return Boolean(this.state.idError || this.state.ipv4Error || this.state.macError);
    },

    editHandler() {
        // console.log("Entering edit handler");
        if (this.nodeError()) {
            return;
        }
        let node = {id: this.state.id, type: this.state.type,
            x: this.state.node.x,
            y: this.state.node.y};
        if (this.state.layer !== "none") {
            node.layer = this.state.layer;
        }
        if (this.state.ipv4) {
            node.ipv4 = this.state.ipv4;
        }
        if (this.state.mac) {
            node.mac = this.state.mac;
        }
        if (this.state.vnid) {
            node.vnid = this.state.vnid;
        }
        // console.log("About to dispatch edit node");
        // console.log(node);
        // Create a new network with the old node swapped out with the edited node
        // Need to update links that may have referenced the old node
        let oldId = this.state.node.id
        let nodes = this.props.net.nodes.filter(n => n.id !== oldId);
        nodes = nodes.concat(node);
        let links = this.props.net.links.map(l => Object.assign({}, l));
        for (let link of links) {
            if (link.source === oldId) {
                link.source = node.id;
            }
            if (link.target === oldId) {
                link.target = node.id;
            }
        }
        this.props.editNode(Object.assign({}, this.props.net, {nodes: nodes, links: links}));
    },

    toggleAddr() {
        this.setState(Object.assign({}, this.state, {addrOpen: !this.state.addrOpen}));
    },

    helpState() {
        if (this.state.idError || this.state.ipv4Error || this.state.macError) {
            return 'danger';
        } else {
            return 'info';
        }
    },

    helpPopover(){
        let errorHeader = null;
        let idErrorP = null;
        let ipv4ErrorP = null;
        let macErrorP = null;
        if (this.state.idError || this.state.ipv4Error || this.state.macError) {
            errorHeader = <p>Errors:</p>;
        }
        if (this.state.idError) {
            idErrorP = <p>{this.state.idError}</p>;
        }
        if (this.state.ipv4Error) {
            ipv4ErrorP = <p>{this.state.ipv4Error}</p>;
        }
        if (this.state.macError) {
            macErrorP = <p>{this.state.macError}</p>;
        }
        return (<Popover id="editNodeHelpPopover" title="Edit Node Help">
            <p>Nodes must have unique IDs and the IDs can only consist of letters and numbers.</p>
            <p>Virtual Network ID (VNID) can be any number or characters you'd like. Typically used
            to model VLAN and such.</p>
            <p>If IPv4 or MAC addresses are given they must be in the proper format and not be already in use
            by another node in the network.</p>
            {errorHeader}
            {idErrorP}
            {ipv4ErrorP}
            {macErrorP}
        </Popover>);
    },

    nodeTypeChange(e) {
        this.setState(Object.assign({}, this.state, {type: e.target.value}));
    },

    nodeLayerChange(e) {
        this.setState(Object.assign({}, this.state, {layer: e.target.value}));
    },



    render(){
        let nodeTypeOptions = nodeTypes.map(function (ntype) {
            return <option value={ntype.id}
                           key={"nType-" + ntype.id}>{ntype.name}</option>;
        });
        let nodeLayerOptions = nodeLayerTypes.map(function (nlayer) {
            return <option value={nlayer.id}
                           key={"nLayer" + nlayer.id}>{nlayer.name}</option>;
        });
        return (
            <Modal dialogComponentClass={DraggableModalDialog}
           enforceFocus={false} backdrop={false} show={this.props.open} onHide={this.props.close}
                   dialogClassName="add-node-net-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Network Node Edit: <em>{this.state.node.id}</em></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal">
                            <Row><Col xs={10} xsOffset={2}><em>Required Node Attributes</em></Col></Row>
                            <Row>
                                <div className={this.idStatus()}> {/* This enables status feedback on input and label  */}
                                    <Col xs={2}>
                                        <label className="control-label">ID</label>
                                    </Col>
                                    <Col xs={3}>
                                        <input type="text" value={this.state.id}
                                               onChange={this.idChange}
                                               className="form-control"/>
                                    </Col>
                                </div>
                                <Col xs={2}>
                                    <label
                                        className="control-label">Type</label>
                                </Col>
                                <Col xs={5}>
                                    <select value={this.state.type}
                                            className="form-control"
                                            onChange={this.nodeTypeChange}>
                                        {nodeTypeOptions}
                                    </select>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={10} xsOffset={2}><em>Optional Node Attribute</em></Col>
                            </Row>
                            <Row>
                                <Col xs={2}><label className="control-label">Layer</label></Col>
                                <Col xs={5}>
                                    <select value={this.state.layer}
                                            className="form-control"
                                            onChange={this.nodeLayerChange}>
                                        {nodeLayerOptions}
                                    </select>
                                </Col>
                                <Col xs={2}><label className="control-label">VNID</label></Col>
                                <Col xs={3}> <input type="text" value={this.state.vnid}
                                               onChange={this.vnidChange}
                                               className="form-control"
                                        />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={10} xsOffset={2}><a
                                    onClick={this.toggleAddr}><em>Optional Node
                                    Addresses</em></a></Col>
                            </Row>
                            <Collapse in={this.state.addrOpen}>
                                <div>
                                    <Row>
                                        <div className={this.ipv4Status()}>
                                        <Col xs={3}>
                                            <label className="control-label">IPv4</label>
                                        </Col>
                                        <Col xs={9}>
                                            <input type="text"
                                                   value={this.state.ipv4}
                                                   className="form-control" onChange={this.ipv4Change}/>
                                        </Col></div>
                                    </Row>
                                    <Row>
                                        <div className={this.macStatus()}>
                                        <Col xs={3}> <label
                                            className="control-label">Ethernet</label></Col>
                                        <Col xs={9}>
                                            <input type="text" onChange={this.macChange}
                                                   value={this.state.mac}
                                                   className="form-control"/>
                                        </Col>
                                            </div>
                                    </Row></div>
                            </Collapse>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary"
                            onClick={this.editHandler} disabled={this.nodeError()}>Apply </Button>
                    <Button onClick={this.props.close}>Cancel</Button>
                    <OverlayTrigger trigger="click" placement="top"
                                    overlay={this.helpPopover()}>
                        <Button bsStyle={this.helpState()}>Help</Button>
                    </OverlayTrigger>
                </Modal.Footer>
            </Modal>
        )
    }
});

function idValidator(id, nodes, node) {
    let myReg = /^[A-Za-z0-9]+$/; //Only letters and numbers no special characters
    if (!myReg.test(id)) {
        return "Node IDs can only contain letters and numbers";
    }
    if (id === node.id) {
        return null;
    }
    if (nodes.find(n => {
            return n.id === id;
        })) {
        return "Node Id is already used, must be unique";
    }
    return null;
}

function ipv4Validator(ipv4, nodes, node) {
    let otherNodes = nodes.filter(n => n.id !== node.id);
    if (!ipv4) return null;
    let ipv4Reg = /^(([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)\.){3}([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)$/;
    if (!ipv4Reg.test(ipv4)) {
        return "Bad IPv4 address";
    }
    if (otherNodes.find(n => {
            return n.ipv4 === ipv4;
        })) {
        return "This IPv4 address is already used, must be unique";
    }
}

function macValidator(mac, nodes, node) {
    let otherNodes = nodes.filter(n => n.id !== node.id);
    if (!mac) return null;
    let ethReg = /^[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}$/;
    if (!ethReg.test(mac)) {
        return ("Bad Ethernet address");
    }
    if (otherNodes.find(n => {
            return n.mac === mac;
        })) {
        return ("This Ethernet address is already used, must be unique");
    }
}

const mapStateToProps = (state) => {
    return {
        open: state.uiState.showNodeEditModal,
        net: state.net,
        netVisInteract: state.netVisInteract
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_NODE_EDIT_DIALOG'});
        },
        editNode: (net) => {
            dispatch({type: 'NET_NODE_EDIT', net: net});
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NodeEditDialog)




// WEBPACK FOOTER //
// ./src/netDraw/NodeEditDialog.js